import { useTranslation } from 'react-i18next';

export default function TransferSection({
    transfers,
    onPickupChange,
    onArrivalChange,
    onDepartureChange,
    lang
}) {

    const { t } = useTranslation();

    return (
        <>
            <h2 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Información de traslados")}</h2>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="pickupLocation" className="u-form-control-hidden u-label fontmontserrat">{t("¿Dónde le gustaría que le recogiéramos? (aeropuerto, ciudad, etc)")}</label>
                <input
                    type="text"
                    placeholder={t("¿Dónde le gustaría que le recogiéramos? (aeropuerto, ciudad, etc)")}
                    id="pickupLocation"
                    name="pickupLocation"
                    value={transfers.pickupLocation}
                    onChange={(e) => onPickupChange(e.target.value)}
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>
            <hr />

            <h2 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Llegada")}</h2>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="arrivaldate" className="u-form-control-hidden u-label fontmontserrat">{t("Fecha")}</label>
                <input
                    type="date"
                    placeholder={t("Fecha")}
                    id="arrivaldate"
                    name="arrivaldate"
                    value={transfers.arrival.date}
                    onChange={(e) =>
                        onArrivalChange("date", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="arrivaltime" className="u-form-control-hidden u-label fontmontserrat">{t("Hora")}</label>
                <input
                    type="time"
                    placeholder={t("Hora")}
                    id="arrivaltime"
                    name="arrivaltime"
                    value={transfers.arrival.time}
                    onChange={(e) =>
                        onArrivalChange("time", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="arrivalairport" className="u-form-control-hidden u-label fontmontserrat">{t("Aeropuerto")}</label>
                <input
                    type="text"
                    placeholder={t("Aeropuerto")}
                    id="arrivalairport"
                    name="arrivalairport"
                    value={transfers.arrival.airport}
                    onChange={(e) =>
                        onArrivalChange("airport", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="arrivalflightnumber" className="u-form-control-hidden u-label fontmontserrat">{t("Nº vuelo")}</label>
                <input
                    type="text"
                    placeholder={t("Nº vuelo")}
                    id="arrivalflightnumber"
                    name="arrivalflightnumber"
                    value={transfers.arrival.flightNumber}
                    onChange={(e) =>
                        onArrivalChange("flightNumber", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="arrivalhotel" className="u-form-control-hidden u-label fontmontserrat">{t("Hotel (si procede)")}</label>
                <input
                    type="text"
                    placeholder={t("Hotel (si procede)")}
                    id="arrivalhotel"
                    name="arrivalhotel"
                    value={transfers.arrival.hotel}
                    onChange={(e) =>
                        onArrivalChange("hotel", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="arrivalhotelPhone" className="u-form-control-hidden u-label fontmontserrat">{t("Teléfono hotel")}</label>
                <input
                    type="text"
                    placeholder={t("Teléfono hotel")}
                    id="arrivalhotelphone"
                    name="arrivalhotelphone"
                    value={transfers.arrival.hotelPhone}
                    onChange={(e) =>
                        onArrivalChange("hotelPhone", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <hr />

            <h2 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Salida")}</h2>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="departuredate" className="u-form-control-hidden u-label fontmontserrat">{t("Fecha")}</label>
                <input
                    type="date"
                    placeholder={t("Fecha")}
                    id="departuredate"
                    name="departuredate"
                    value={transfers.departure.date}
                    onChange={(e) =>
                        onDepartureChange("date", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="departuretime" className="u-form-control-hidden u-label fontmontserrat">{t("Hora")}</label>
                <input
                    type="time"
                    placeholder={t("Hora")}
                    id="departuretime"
                    name="departuretime"
                    value={transfers.departure.time}
                    onChange={(e) =>
                        onDepartureChange("time", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="departureairport" className="u-form-control-hidden u-label fontmontserrat">{t("Aeropuerto")}</label>
                <input
                    type="text"
                    placeholder={t("Aeropuerto")}
                    id="departureairport"
                    name="departureairport"
                    value={transfers.departure.airport}
                    onChange={(e) =>
                        onDepartureChange("airport", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="departureflightnumber" className="u-form-control-hidden u-label fontmontserrat">{t("Nº vuelo")}</label>
                <input
                    type="text"
                    placeholder={t("Nº vuelo")}
                    id="departureflightnumber"
                    name="departureflightnumber"
                    value={transfers.departure.flightNumber}
                    onChange={(e) =>
                        onDepartureChange("flightNumber", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="departurehotel" className="u-form-control-hidden u-label fontmontserrat">{t("Hotel (Si procede)")}</label>
                <input
                    type="text"
                    placeholder={t("Hotel (Si procede)")}
                    id="departurehotel"
                    name="departurehotel"
                    value={transfers.departure.hotel}
                    onChange={(e) =>
                        onDepartureChange("hotel", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="departurehotelphone" className="u-form-control-hidden u-label fontmontserrat">{t("Teléfono hotel")}</label>
                <input
                    type="text"
                    placeholder={t("Teléfono hotel")}
                    id="departurehotelphone"
                    name="departurehotelphone"
                    value={transfers.departure.hotelPhone}
                    onChange={(e) =>
                        onDepartureChange("hotelPhone", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

        </>
    );
}
